import { useMemo } from 'react';

import { options_theme } from '../../Options/constants';
import { useThemeContext } from '../../theme/context/ThemeContext';
import { OptionsTheme, OptionsThemePartial } from '../types';

export const useOptionsTheme = (
  theme: Partial<OptionsThemePartial> = options_theme
): OptionsTheme => {
  const {
    theme: {
      options: { general, settings, background, color },
    },
  } = useThemeContext();

  return useMemo(
    () => ({
      general: { ...general, ...theme.general },
      settings: { ...settings, ...theme.settings },
      background: { ...background, ...theme.background },
      color: { ...color, ...theme.color },
    }),
    [theme, settings, general, background, color]
  );
};
